export default __webpack_public_path__ + "static/media/sales.1d3965d2.svg";